import React from "react";
import { keyframes } from "@emotion/core";
import { styled } from "@styles/theme";
import { Flex } from "../ResponsiveBox";

const scaleUp = keyframes`
  from { transform: scale(0); }
  to { transform: scale(1); }
`;

const scaleUpDelay = keyframes`
  from { transform: scale(0); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
`;

const scaleSVG = keyframes`
  from { stroke-dashoffset: 100; }
  to { stroke-dashoffset: 0; }
`;

const Circle = styled(Flex)`
  border-radius: 50%;
  animation: ${scaleUp} 0.6s ease-out;
`;

const InnerCircle = styled(Flex)`
  border-radius: 50%;
  animation: ${scaleUpDelay} 0.6s ease-out;
`;

const CheckmarkSVG = styled.svg`
  width: 80px;
  height: 80px;
  fill: none;
  stroke: #fff;
  stroke-width: 2.5;
  stroke-linecap: round;
  stroke-dasharray: 100 100;
  stroke-dashoffset: 100;
  animation: ${scaleSVG} 1.5s ease-out forwards;
  animation-delay: 0.5s;
`;

const AnimatedCheckmark = () => {
  return (
    <Circle
      width={148}
      height={148}
      bg="green.200"
      m="auto"
      alignItems="center"
      justify="center"
    >
      <InnerCircle
        width={124}
        height={124}
        bg="green.600"
        alignItems="center"
        justify="center"
      >
        <CheckmarkSVG viewBox="0 0 32 32">
          <path d="M9 16l5 5 9-9" />
        </CheckmarkSVG>
      </InnerCircle>
    </Circle>
  );
};

export default AnimatedCheckmark;
